<form [formGroup]="form">
  <div class="modal-content m-0">
    <div class="modal-header">
      @if (resampleKitId) {
        <p class="mb-0">
          {{ 'sample.form.resample' | translate }}
        </p>
      } @else if (sampleId) {
        <p class="mb-0">
          {{ 'sample.form.editTitle' | translate }}
        </p>
      } @else {
        <p class="mb-0">
          {{ 'sample.form.title' | translate }}
        </p>
      }
      <i
        class="fa-light fa-xmark ms-auto cursor-pointer"
        data-cy="sample-dialog-close-icon"
        (click)="modalRef.close()"
      ></i>
    </div>
    <div class="modal-body">
      <section>
        <p class="caption mb-1">
          {{ 'sample.form.kitInformation' | translate }}
        </p>
        <hr class="mt-0" />
        <div class="row mb-3">
          <div class="col-12 col-md-6">
            <div class="row align-items-center">
              <div class="col-12 col-sm-4 mb-1">
                <label for="partnerId">{{
                  'sample.form.partner' | translate
                }}</label>
              </div>
              <div class="col-12 col-sm-8">
                <app-partner-typeahead
                  name="partnerId"
                  id="partnerId"
                  class="w-50"
                  [fieldSize]="'medium'"
                  [disabled]="true"
                  [control]="$any(form.controls.partnerId)"
                />
              </div>
            </div>
            <div class="row justify-content-end">
              <div class="col-12 col-sm-8">
                <app-validation-error
                  for="partnerId"
                  translations="validation.generic"
                ></app-validation-error>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 mt-3 mt-md-0">
            <div class="row align-items-center">
              <div class="col-12 col-sm-4 mb-1">
                <label for="doctor">{{
                  'sample.form.doctor' | translate
                }}</label>
              </div>
              <div class="col-12 col-sm-8">
                @if (doctors$ | async; as doctors) {
                  <app-select
                    id="doctor"
                    data-cy="doctor-select"
                    [placeholder]="
                      doctors.length
                        ? ('sample.form.placeholders.selectDoctor' | translate)
                        : ('sample.form.placeholders.noDoctorsAvailable'
                          | translate)
                    "
                    [formControl]="
                      $any(form.get('serviceInformation.shared.doctorId'))
                    "
                  >
                    @for (doctor of doctors; track doctor?.id) {
                      <app-select-option
                        [value]="doctor?.id ?? null"
                        [label]="doctor?.name"
                      />
                    }
                  </app-select>
                } @else {
                  <app-select
                    id="doctor"
                    data-cy="disabled-doctor-select"
                    [placeholder]="
                      'sample.form.placeholders.selectPartnerFirst' | translate
                    "
                  />
                }
              </div>
            </div>
            <div class="row justify-content-end">
              <div class="col-12 col-sm-8">
                <app-validation-error
                  for="serviceInformation.shared.doctorId"
                  translations="validation.generic"
                ></app-validation-error>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-12 col-md-6">
            <div class="row align-items-center">
              <div class="col-12 col-sm-4 mb-1">
                <label for="productId">{{
                  'sample.form.product' | translate
                }}</label>
              </div>
              <div class="col-12 col-sm-8">
                @if (availableProducts$ | async; as availableProducts) {
                  <app-select
                    id="productId"
                    formControlName="productId"
                    data-cy="product-select"
                    [placeholder]="
                      availableProducts.length
                        ? ('sample.form.placeholders.selectProduct' | translate)
                        : ('sample.form.placeholders.noProductsAvailable'
                          | translate)
                    "
                  >
                    @for (product of availableProducts; track product?.id) {
                      <app-select-option
                        [value]="product?.id"
                        [label]="product?.internalName"
                      />
                    }
                  </app-select>
                }
              </div>
            </div>
            <div class="row justify-content-end">
              <div class="col-12 col-sm-8">
                <app-validation-error
                  for="productId"
                  translations="validation.generic"
                ></app-validation-error>
              </div>
            </div>
          </div>
          @if (!resampleKitId) {
            <div class="col-12 col-md-6 align-self-center mt-3 mt-md-0">
              <div class="row align-items-center">
                <div class="col-12 col-sm-4 mb-1">
                  <label for="kitId">{{ 'sample.form.kit' | translate }}</label>
                </div>
                <div class="col-12 col-sm-8">
                  @if (!sampleId) {
                    @if (kits$ | async; as kits) {
                      <app-select
                        id="kitId"
                        formControlName="kitId"
                        data-cy="kit-select"
                        [placeholder]="
                          kits.length
                            ? ('sample.form.placeholders.selectKit' | translate)
                            : ('sample.form.placeholders.noKitsAvailable'
                              | translate)
                        "
                      >
                        @for (kit of kits; track kit?.id) {
                          <app-select-option
                            [value]="kit?.id"
                            [label]="kit.id"
                          />
                        }
                      </app-select>
                    } @else {
                      <app-select
                        id="kitId"
                        formControlName="kitId"
                        [placeholder]="
                          'sample.form.placeholders.selectProductFirst'
                            | translate
                        "
                        formControlName="kitId"
                      />
                    }
                  } @else {
                    <b>{{ form.get('kitId').value }}</b>
                  }
                </div>
              </div>
              <div class="row justify-content-end">
                <div class="col-12 col-sm-8">
                  <app-validation-error
                    for="kitId"
                    translations="validation.generic"
                  ></app-validation-error>
                </div>
              </div>
            </div>
          }
        </div>

        @if (resampleKitId) {
          <div class="row mb-3">
            <div class="col-12 col-md-6 align-self-center">
              <div class="row">
                <div class="col-12 col-sm-4 mb-1">
                  <label for="productId">{{
                    'sample.form.previousKit' | translate
                  }}</label>
                </div>
                <div class="col-12 col-sm-8">
                  <b>{{ resampleKitId }}</b>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 mt-3 mt-md-0">
              <div class="row align-items-center">
                <div class="col-12 col-sm-4 mb-1">
                  <label for="kitId">{{ 'sample.form.kit' | translate }}</label>
                </div>
                <div class="col-12 col-sm-8">
                  @if (kits$ | async; as kits) {
                    <app-select
                      id="kitId"
                      formControlName="kitId"
                      data-cy="kit-select"
                      [placeholder]="
                        kits.length
                          ? ('sample.form.placeholders.selectKit' | translate)
                          : ('sample.form.placeholders.noKitsAvailable'
                            | translate)
                      "
                    >
                      @for (kit of kits; track kit?.id) {
                        <app-select-option [value]="kit?.id" [label]="kit.id" />
                      }
                    </app-select>
                  } @else {
                    <app-select
                      id="kitId"
                      formControlName="kitId"
                      [placeholder]="
                        'sample.form.placeholders.selectProductFirst'
                          | translate
                      "
                      formControlName="kitId"
                    />
                  }
                </div>
              </div>
              <div class="row justify-content-end">
                <div class="col-12 col-sm-8">
                  <app-validation-error
                    for="kitId"
                    translations="validation.generic"
                  ></app-validation-error>
                </div>
              </div>
            </div>
          </div>
        }

        <div [formGroup]="dovForm" class="row mb-3">
          <div class="col-12 col-md-6">
            <div class="row align-items-center">
              <div class="col-12 col-sm-4 mb-1">
                <label for="dateOfVenipuncture">{{
                  'sample.form.dateOfVenipuncture' | translate
                }}</label>
              </div>
              <div class="col-12 col-sm-8">
                <input
                  ngbDatepicker
                  class="form-control"
                  id="dateOfVenipuncture"
                  formControlName="date"
                  container="body"
                  #datePicker="ngbDatepicker"
                  [placeholder]="
                    'sample.form.placeholders.dateFormat' | translate
                  "
                  (click)="datePicker.toggle()"
                  data-cy="date-of-venipuncture-input"
                />
              </div>
            </div>
            <div class="row justify-content-end">
              <div class="col-12 col-sm-8">
                <app-validation-error
                  for="date"
                  translations="validation.generic"
                ></app-validation-error>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 mt-3 mt-md-0">
            <div class="row align-items-center">
              <div class="col-12 col-sm-4 mb-1">
                <label for="dateOfVenipuncture">{{
                  'sample.form.timeOfVenipuncture' | translate
                }}</label>
              </div>
              <div class="col-12 col-sm-8">
                <div class="row">
                  <div class="col-6 col-hours">
                    <input
                      type="number"
                      class="form-control"
                      formControlName="timeHour"
                    />
                  </div>
                  <div class="col-6">
                    <input
                      type="number"
                      class="form-control"
                      formControlName="timeMinutes"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row justify-content-end">
              <div class="col-12 col-sm-8">
                <div class="row">
                  <div class="col-6">
                    <app-validation-error
                      for="timeHour"
                      translations="validation.generic"
                    ></app-validation-error>
                  </div>
                  <div class="col-6">
                    <app-validation-error
                      for="timeMinutes"
                      translations="validation.generic"
                    ></app-validation-error>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      @if (
        ((!sampleId || resampleKitId) && fieldSet.length) ||
        fieldSet.includes(SampleFields.EditFieldsAvailable)
      ) {
        <ng-container formGroupName="serviceInformation">
          <section
            *appRequirePermission="
              sampleId && !resampleKitId ? ['medicalInformation'] : []
            "
          >
            <p class="caption mb-1">
              {{ 'sample.form.serviceInformation' | translate }}
            </p>
            <hr class="mt-0" />
            <ng-container formGroupName="shared">
              @if (fieldSet.includes(SampleFields.SampleType)) {
                <div class="row form-group">
                  <div class="col-12 col-sm-6">
                    <div class="row align-items-center">
                      <div class="col-12 col-sm-4 mb-1">
                        <label>
                          {{ 'sample.form.sampleType' | translate }}</label
                        >
                      </div>
                      <div class="col-12 col-sm-8">
                        <div class="row">
                          <div class="col-12">
                            <app-select
                              class="w-100"
                              id="sampleType"
                              formControlName="sampleType"
                              [placeholder]="
                                'sample.form.placeholders.sampleType'
                                  | translate
                              "
                            >
                              @for (type of sampleTypes; track type) {
                                <app-select-option
                                  [value]="type"
                                  [label]="
                                    'sample.form.sampleTypes.' +
                                      sampleTypeKey(type) | translate
                                  "
                                />
                              }
                            </app-select>
                          </div>
                        </div>
                      </div>
                      <div class="row justify-content-end p-0 m-0">
                        <div class="col-12 col-sm-8">
                          @if (sampleTypes.length) {
                            <app-validation-error
                              for="sampleType"
                              translations="validation.sampleType"
                            ></app-validation-error>
                          } @else {
                            <div class="pt-1 pb-2">
                              <span
                                class="text-danger caption"
                                data-cy="no-sample-types-error"
                              >
                                {{
                                  'sample.form.noSampleTypesConfigured'
                                    | translate
                                }}
                              </span>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                  @if (
                    form.get('serviceInformation.shared.sampleType').value ===
                    SampleType.Other
                  ) {
                    <div class="col-12 col-sm-6">
                      <div class="row align-items-center">
                        <div class="col-12 col-sm-4 mb-1">
                          <label for="otherType">
                            {{
                              'sample.form.sampleTypeOther' | translate
                            }}</label
                          >
                        </div>
                        <div class="col-12 col-sm-8">
                          <input
                            class="form-control"
                            id="otherType"
                            formControlName="otherType"
                            appInputValidationStatus
                            data-cy="otherType-input"
                            [placeholder]="
                              'sample.form.placeholders.sampleTypeOther'
                                | translate
                            "
                          />
                        </div>
                        <div class="row justify-content-end p-0 m-0">
                          <div class="col-12 col-sm-8">
                            <app-validation-error
                              for="otherType"
                              translations="validation.generic"
                            ></app-validation-error>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
              @if (fieldSet.includes(SampleFields.Participant)) {
                @let participants = participants$ | async;
                <div class="row form-group">
                  <div class="col-12 col-sm-6">
                    <div class="row align-items-center">
                      <div class="col-12 col-sm-4 mb-1">
                        <label for="participantId">
                          {{ 'sample.form.participant' | translate }}</label
                        >
                      </div>
                      <div class="col-12 col-sm-8">
                        <app-select
                          class="w-100"
                          id="participantId"
                          formControlName="participantId"
                          data-cy="participant-select"
                          [placeholder]="
                            (participants?.length
                              ? 'sample.form.placeholders.participant'
                              : 'sample.form.placeholders.noParticipantsAvailable'
                            ) | translate
                          "
                        >
                          @for (
                            participant of participants;
                            track participant.id
                          ) {
                            <app-select-option
                              [value]="participant.id"
                              [label]="
                                participant.firstName +
                                ' ' +
                                participant.lastName +
                                ' (' +
                                ('serviceData.relationship.' +
                                  participant.relationship | translate) +
                                ')'
                              "
                            />
                          }
                        </app-select>
                      </div>
                      <div class="row justify-content-end p-0 m-0">
                        <div class="col-12 col-sm-8">
                          <app-validation-error
                            for="participantId"
                            translations="validation.generic"
                          ></app-validation-error>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
              @if (fieldSet.includes(SampleFields.GestationAge)) {
                <div class="row mb-3">
                  <div class="col-12 col-md-6">
                    <div
                      class="row align-items-center"
                      formGroupName="gestationAge"
                    >
                      <div class="col-4">
                        <label>
                          {{ 'sample.form.gestationAge' | translate }}</label
                        >
                      </div>
                      <div class="col-12 col-sm-8">
                        <div class="row m-0">
                          <div class="col-6 ps-0">
                            <input
                              class="form-control"
                              type="number"
                              formControlName="week"
                              id="gestationWeek"
                              [placeholder]="
                                'sample.form.placeholders.week' | translate
                              "
                              [readonly]="
                                form.get(
                                  'serviceInformation.shared.isGestationAgeAutomaticallyCalculated'
                                ).value
                              "
                            />
                          </div>
                          <div class="col-6 pe-0">
                            <input
                              class="form-control"
                              type="number"
                              formControlName="day"
                              id="gestationDay"
                              [placeholder]="
                                'sample.form.placeholders.day' | translate
                              "
                              [readonly]="
                                form.get(
                                  'serviceInformation.shared.isGestationAgeAutomaticallyCalculated'
                                ).value
                              "
                            />
                          </div>
                        </div>
                      </div>
                      <div class="row justify-content-end p-0 m-0">
                        <div class="col-6 col-sm-4">
                          <app-validation-error
                            for="week"
                            translations="validation.generic"
                          ></app-validation-error>
                        </div>
                        <div class="col-6 col-sm-4">
                          <app-validation-error
                            for="day"
                            translations="validation.generic"
                          ></app-validation-error>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-1">
                      <div class="col-12 col-sm-8 offset-sm-4">
                        <div class="form-check form-check-lg">
                          <input
                            type="checkbox"
                            class="form-check-input me-2"
                            formControlName="isGestationAgeAutomaticallyCalculated"
                          />
                          <label class="form-check-label">
                            {{ 'sample.form.autoCalculate' | translate }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }

              @if (fieldSet.includes(SampleFields.UltrasoundDate)) {
                <div class="row mb-3">
                  <div class="col-12 col-md-6">
                    <div class="row align-items-center">
                      <div class="col-12 col-sm-4 mb-1">
                        <label for="ultrasoundDate">{{
                          'sample.form.ultrasoundDate' | translate
                        }}</label>
                      </div>
                      <div class="col-12 col-sm-8">
                        <input
                          ngbDatepicker
                          class="form-control"
                          id="dateOfVenipuncture"
                          formControlName="ultrasoundDate"
                          container="body"
                          #datePicker="ngbDatepicker"
                          [placeholder]="
                            'sample.form.placeholders.dateFormat' | translate
                          "
                          (click)="datePicker.toggle()"
                        />
                      </div>
                    </div>
                    <div class="row justify-content-end">
                      <div class="col-12 col-sm-8">
                        <app-validation-error
                          for="ultrasoundDate"
                          translations="validation.generic"
                        ></app-validation-error>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </ng-container>
            <ng-container formGroupName="nipt">
              @if (fieldSet.includes(SampleFields.PriorScreeningTest)) {
                <ng-container formGroupName="priorScreeningTest">
                  <div class="row mb-3">
                    <div class="col-12 col-md-6">
                      <div class="row align-items-center">
                        <div class="col-12 col-sm-4 mb-1">
                          <label for="priorScreeningTest">{{
                            'sample.form.priorScreeningTest' | translate
                          }}</label>
                        </div>
                        <div class="col-12 col-sm-8">
                          <app-select
                            class="w-100"
                            id="priorScreeningTest"
                            formControlName="priorScreeningTestType"
                            [placeholder]="
                              'sample.form.placeholders.priorScreeningTest'
                                | translate
                            "
                          >
                            @for (
                              type of Object.keys(PriorScreeningTestType);
                              track type
                            ) {
                              <app-select-option
                                [value]="type"
                                [label]="
                                  'sample.form.priorScreeningTestType.' + type
                                    | translate
                                "
                              />
                            }
                          </app-select>
                        </div>
                      </div>
                      <div class="row justify-content-end">
                        <div class="col-12 col-sm-8">
                          <app-validation-error
                            for="priorScreeningTestType"
                            translations="validation.generic"
                          ></app-validation-error>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 col-md-6" formGroupName="firstTRisks">
                      <div class="row align-items-center">
                        <div class="col-12 col-sm-4 mb-1">
                          <label for="firstT21Risk">{{
                            'sample.form.firstT21Risk' | translate
                          }}</label>
                        </div>
                        <div class="col-12 col-sm-8">
                          <input
                            class="form-control"
                            formControlName="t21Risk"
                            id="firstT21Risk"
                            [placeholder]="
                              'sample.form.placeholders.firstT21Risk'
                                | translate
                            "
                          />
                        </div>
                      </div>
                      <div class="row mb-3 justify-content-end">
                        <div class="col-12 col-sm-8">
                          <app-validation-error
                            for="t21Risk"
                            translations="validation.generic"
                          ></app-validation-error>
                        </div>
                      </div>
                      <div class="row align-items-center">
                        <div class="col-12 col-sm-4 mb-1">
                          <label for="firstT18Risk">{{
                            'sample.form.firstT18Risk' | translate
                          }}</label>
                        </div>
                        <div class="col-12 col-sm-8">
                          <input
                            class="form-control"
                            formControlName="t18Risk"
                            id="firstT18Risk"
                            [placeholder]="
                              'sample.form.placeholders.firstT18Risk'
                                | translate
                            "
                          />
                        </div>
                      </div>
                      <div class="row mb-3 justify-content-end">
                        <div class="col-12 col-sm-8">
                          <app-validation-error
                            for="t18Risk"
                            translations="validation.generic"
                          ></app-validation-error>
                        </div>
                      </div>
                      <div class="row align-items-center">
                        <div class="col-12 col-sm-4 mb-1">
                          <label for="firstT13Risk">{{
                            'sample.form.firstT13Risk' | translate
                          }}</label>
                        </div>
                        <div class="col-12 col-sm-8">
                          <input
                            class="form-control"
                            formControlName="t13Risk"
                            id="firstT13Risk"
                            [placeholder]="
                              'sample.form.placeholders.firstT13Risk'
                                | translate
                            "
                          />
                        </div>
                      </div>
                      <div class="row mb-3 justify-content-end">
                        <div class="col-12 col-sm-8">
                          <app-validation-error
                            for="t13Risk"
                            translations="validation.generic"
                          ></app-validation-error>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-6" formGroupName="secondTRisks">
                      <div class="row align-items-center">
                        <div class="col-12 col-sm-4 mb-1">
                          <label for="secondT21Risk">{{
                            'sample.form.secondT21Risk' | translate
                          }}</label>
                        </div>
                        <div class="col-12 col-sm-8">
                          <input
                            class="form-control"
                            formControlName="t21Risk"
                            id="secondT21Risk"
                            [placeholder]="
                              'sample.form.placeholders.secondT21Risk'
                                | translate
                            "
                          />
                        </div>
                      </div>
                      <div class="row mb-3 justify-content-end">
                        <div class="col-12 col-sm-8">
                          <app-validation-error
                            for="t21Risk"
                            translations="validation.generic"
                          ></app-validation-error>
                        </div>
                      </div>
                      <div class="row align-items-center">
                        <div class="col-12 col-sm-4 mb-1">
                          <label for="secondT18Risk">{{
                            'sample.form.secondT18Risk' | translate
                          }}</label>
                        </div>
                        <div class="col-12 col-sm-8">
                          <input
                            class="form-control"
                            formControlName="t18Risk"
                            id="secondT18Risk"
                            [placeholder]="
                              'sample.form.placeholders.secondT18Risk'
                                | translate
                            "
                          />
                        </div>
                      </div>
                      <div class="row mb-3 justify-content-end">
                        <div class="col-12 col-sm-8">
                          <app-validation-error
                            for="t18Risk"
                            translations="validation.generic"
                          ></app-validation-error>
                        </div>
                      </div>
                      <div class="row align-items-center">
                        <div class="col-12 col-sm-4 mb-1">
                          <label for="secondT13Risk">{{
                            'sample.form.secondT13Risk' | translate
                          }}</label>
                        </div>
                        <div class="col-12 col-sm-8">
                          <input
                            class="form-control"
                            formControlName="t13Risk"
                            id="secondT13Risk"
                            [placeholder]="
                              'sample.form.placeholders.secondT13Risk'
                                | translate
                            "
                          />
                        </div>
                      </div>
                      <div class="row mb-3 justify-content-end">
                        <div class="col-12 col-sm-8">
                          <app-validation-error
                            for="t13Risk"
                            translations="validation.generic"
                          ></app-validation-error>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              }
            </ng-container>
            <ng-container formGroupName="shared">
              @if (!sampleId || resampleKitId) {
                <ng-container formGroupName="heparinTherapy">
                  <app-service-data-form-condition-history
                    [config]="{
                      type: RadioFormType.Double,
                      title: {
                        question:
                          'serviceData.form.heparinTherapy.hasReceived'
                          | translate,
                        subQuestion:
                          'serviceData.form.heparinTherapy.isRelevant'
                          | translate: { hours: 24 },
                      },
                      validationTranslation: {
                        subAnswer: 'serviceData.form.validation.heparinTherapy',
                      },
                    }"
                    [fieldSet]="fieldSet"
                    [field]="ServiceDataFields.HeparinTherapy"
                  />
                </ng-container>
                <ng-container formGroupName="patientHistory">
                  <app-sample-patient-history-information
                    [fieldSet]="fieldSet"
                  ></app-sample-patient-history-information>
                </ng-container>
              }
            </ng-container>
          </section>
        </ng-container>
      }

      @if (form.get('kitId').value) {
        <section>
          <p class="caption mb-1">
            {{ 'sample.form.shippingInformation' | translate }}
          </p>
          <hr class="mt-0" />
          <div class="row mb-3">
            <div class="col-12 col-md-6" formGroupName="shippingInformation">
              <div class="row align-items-center">
                <div class="col-12 col-sm-4 mb-1">
                  <label for="waybill">{{
                    'sample.form.waybill' | translate
                  }}</label>
                </div>
                <div class="col-12 col-sm-8">
                  <input
                    appDhlWaybill
                    class="form-control"
                    type="text"
                    id="waybill"
                    formControlName="waybill"
                    appInputValidationStatus
                    [placeholder]="
                      'sample.form.placeholders.waybill' | translate
                    "
                    [readonly]="(awbModel$ | async) !== awbModels.pregenerated"
                  />
                  <input
                    class="form-control"
                    type="hidden"
                    formControlName="documentId"
                  />
                </div>
              </div>
              <div class="row justify-content-end">
                <div class="col-12 col-sm-8">
                  <app-validation-error
                    for="waybill"
                    translations="sample.form.validation.waybill"
                  ></app-validation-error>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 mt-3 mt-md-0">
              <div class="row">
                <app-waybill-generation
                  [partnerId]="form.value.partnerId"
                  [kitId]="form.get('kitId').value"
                  [doctorId]="form.value.serviceInformation.shared.doctorId"
                  [awbModel]="awbModel$ | async"
                  [address]="address"
                  (waybillGenerated)="onWaybillGenerated($event)"
                ></app-waybill-generation>
              </div>
            </div>
          </div>
        </section>
      }
      <section
        *appRequirePermission="
          sampleId && !resampleKitId ? ['sample.edit.sampleNotes'] : []
        "
      >
        <p class="caption mb-1">
          {{ 'sample.form.otherInformation' | translate }}
        </p>
        <hr class="mt-0" />
        <div class="row mb-3">
          <div class="col-12">
            <div class="row align-items-center">
              <div class="col-12 col-sm-2 mb-1">
                <label for="notes">{{ 'sample.form.notes' | translate }}</label>
              </div>
              <div class="col-12 col-sm-10">
                <textarea
                  class="form-control"
                  formControlName="notes"
                  name="notes"
                  id="notes"
                  [placeholder]="'sample.form.placeholders.notes' | translate"
                ></textarea>
              </div>
            </div>
            <div class="row justify-content-end">
              <div class="col-12 col-sm-10">
                <app-validation-error
                  for="notes"
                  translations="validation.generic"
                ></app-validation-error>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="modal-footer">
      <button
        class="btn btn-primary"
        data-cy="sample-dialog-create-btn"
        [disabled]="loading"
        [class.loading]="loading"
        (click)="submit()"
      >
        {{
          (this.sampleId && !this.resampleKitId
            ? 'common.buttons.btnUpdate'
            : 'common.buttons.btnCreate'
          ) | translate
        }}
      </button>
    </div>
  </div>
</form>
